import { PoliciesView } from "../_components";

export default function DevicesProfilesPage() {
  return <PoliciesView />;
}
